import datetimepicker from "./datetimepicker.vue";
export default datetimepicker;



// WEBPACK FOOTER //
// ./src/components/_datetimepicker/index.js